/* tslint:disable */
/* eslint-disable */
/**
 * leverup Service Application
 * Documentation for your application APIs v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PnlChartDataResponse,
  PortfolioResponse,
  TradeOverviewResponse,
} from '../models/index';

export interface HandleGetUserPnlChartData0rUb6eYRequest {
    userAddress: string;
    timeframe: HandleGetUserPnlChartData0rUb6eYTimeframeEnum;
    isAfterFee: boolean;
    blockchain: HandleGetUserPnlChartData0rUb6eYBlockchainEnum;
}

export interface HandleGetUserPortfolioGZuys9oRequest {
    userAddress: string;
}

export interface HandleGetUserTradeOverviewMZd014YRequest {
    userAddress: string;
    timeframe: HandleGetUserTradeOverviewMZd014YTimeframeEnum;
    isAfterFee: boolean;
    blockchain: HandleGetUserTradeOverviewMZd014YBlockchainEnum;
}

/**
 * 
 */
export class PortfolioControllerApi extends runtime.BaseAPI {

    /**
     */
    async handleGetUserPnlChartData0rUb6eYRaw(requestParameters: HandleGetUserPnlChartData0rUb6eYRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PnlChartDataResponse>> {
        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling handleGetUserPnlChartData0rUb6eY().'
            );
        }

        if (requestParameters['timeframe'] == null) {
            throw new runtime.RequiredError(
                'timeframe',
                'Required parameter "timeframe" was null or undefined when calling handleGetUserPnlChartData0rUb6eY().'
            );
        }

        if (requestParameters['isAfterFee'] == null) {
            throw new runtime.RequiredError(
                'isAfterFee',
                'Required parameter "isAfterFee" was null or undefined when calling handleGetUserPnlChartData0rUb6eY().'
            );
        }

        if (requestParameters['blockchain'] == null) {
            throw new runtime.RequiredError(
                'blockchain',
                'Required parameter "blockchain" was null or undefined when calling handleGetUserPnlChartData0rUb6eY().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['timeframe'] != null) {
            queryParameters['timeframe'] = requestParameters['timeframe'];
        }

        if (requestParameters['isAfterFee'] != null) {
            queryParameters['is_after_fee'] = requestParameters['isAfterFee'];
        }

        if (requestParameters['blockchain'] != null) {
            queryParameters['blockchain'] = requestParameters['blockchain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/portfolio/{user_address}/pnl_chart_data`.replace(`{${"user_address"}}`, encodeURIComponent(String(requestParameters['userAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async handleGetUserPnlChartData0rUb6eY(requestParameters: HandleGetUserPnlChartData0rUb6eYRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PnlChartDataResponse> {
        const response = await this.handleGetUserPnlChartData0rUb6eYRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async handleGetUserPortfolioGZuys9oRaw(requestParameters: HandleGetUserPortfolioGZuys9oRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioResponse>> {
        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling handleGetUserPortfolioGZuys9o().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/portfolio/{user_address}/portfolio_data`.replace(`{${"user_address"}}`, encodeURIComponent(String(requestParameters['userAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async handleGetUserPortfolioGZuys9o(requestParameters: HandleGetUserPortfolioGZuys9oRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioResponse> {
        const response = await this.handleGetUserPortfolioGZuys9oRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async handleGetUserTradeOverviewMZd014YRaw(requestParameters: HandleGetUserTradeOverviewMZd014YRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TradeOverviewResponse>> {
        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling handleGetUserTradeOverviewMZd014Y().'
            );
        }

        if (requestParameters['timeframe'] == null) {
            throw new runtime.RequiredError(
                'timeframe',
                'Required parameter "timeframe" was null or undefined when calling handleGetUserTradeOverviewMZd014Y().'
            );
        }

        if (requestParameters['isAfterFee'] == null) {
            throw new runtime.RequiredError(
                'isAfterFee',
                'Required parameter "isAfterFee" was null or undefined when calling handleGetUserTradeOverviewMZd014Y().'
            );
        }

        if (requestParameters['blockchain'] == null) {
            throw new runtime.RequiredError(
                'blockchain',
                'Required parameter "blockchain" was null or undefined when calling handleGetUserTradeOverviewMZd014Y().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['timeframe'] != null) {
            queryParameters['timeframe'] = requestParameters['timeframe'];
        }

        if (requestParameters['isAfterFee'] != null) {
            queryParameters['is_after_fee'] = requestParameters['isAfterFee'];
        }

        if (requestParameters['blockchain'] != null) {
            queryParameters['blockchain'] = requestParameters['blockchain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/portfolio/{user_address}/trade_overview`.replace(`{${"user_address"}}`, encodeURIComponent(String(requestParameters['userAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async handleGetUserTradeOverviewMZd014Y(requestParameters: HandleGetUserTradeOverviewMZd014YRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TradeOverviewResponse> {
        const response = await this.handleGetUserTradeOverviewMZd014YRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum HandleGetUserPnlChartData0rUb6eYTimeframeEnum {
    AllTime = 'ALL_TIME',
    Days7 = 'DAYS_7',
    Days30 = 'DAYS_30',
    Days60 = 'DAYS_60'
}
/**
  * @export
  * @enum {string}
  */
export enum HandleGetUserPnlChartData0rUb6eYBlockchainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum HandleGetUserTradeOverviewMZd014YTimeframeEnum {
    AllTime = 'ALL_TIME',
    Days7 = 'DAYS_7',
    Days30 = 'DAYS_30',
    Days60 = 'DAYS_60'
}
/**
  * @export
  * @enum {string}
  */
export enum HandleGetUserTradeOverviewMZd014YBlockchainEnum {
    Monad = 'MONAD'
}
